module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAQCAYAAADESFVDAAAABHNCSVQICAgIfAhkiAAAAHZJREFUKFOF0sENgCAMBdDPpGpCQo+u4AjeIOGAm7iBboSBCBGk0PNrftN8obW9AVxEcgEzwhjrAEzew3FQhOURjGgEM+rBAnHwh1qwiSq4DxHgt24cgEMpObOHJxCimy/4ggKlr9cgox6IaAQieqtyEsmVq8oDP+9bukBY9x0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/accountSeting/RightIcon.png
// module id = MKjz
// module chunks = 3